import { gql } from "@apollo/client";

export const REJECT_INVOICE_UPLOAD_DOCUMENT = gql`
  mutation rejectInvoiceUploadDocument($input: RejectUploadDocumentInput!) {
    documentHandler {
      rejectInvoiceUploadDocument(input: $input) {
        success
      }
    }
  }
`;
